import { render, staticRenderFns } from "./MatterEvidenceDetectionForm.vue?vue&type=template&id=710fa7bc&"
import script from "./MatterEvidenceDetectionForm.vue?vue&type=script&lang=js&"
export * from "./MatterEvidenceDetectionForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterEvidenceDetectionForm.vue?vue&type=style&index=0&id=710fa7bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports